// path: src/Home.js
import React, { useState } from "react";
import Login from "./Login";
import "./App.css";
import DifficultyDialog from "./Components/DifficultyDialog";
import {
    CHALLENGING_START_LEVEL,
    INSANE_START_LEVEL,
    scoreAtStartOfLevel,
} from "./utils/progression";

const Home = ({
    onPlay,
    onCollection,
    onLoginSuccess,
    onLogout,
    isAuthenticated,
    user,
}) => {
    const [difficultyOpen, setDifficultyOpen] = useState(false);

    const handlePlayClick = () => {
    setDifficultyOpen(true);
    };

    const handlePickDifficulty = (mode) => {
    let startLevel = 1;
    if (mode === "challenging") startLevel = CHALLENGING_START_LEVEL;
    if (mode === "insane") startLevel = INSANE_START_LEVEL;

    const startScore = scoreAtStartOfLevel(startLevel);

    // onPlay is App.goPlay; we now pass options
    onPlay({ startLevel, startScore });
    setDifficultyOpen(false);
    };

    return (
    <div className="homeScreen">
        <div className="homeCard">
        <img
            src="images/home-hero.png"
            alt="Memory Mix-Up"
            className="homeImage"
        />

        <h1 className="homeTitle impactFont">Memory Mix-Up</h1>

        <div className="homeButtons">
            <button className="homePrimaryButton" onClick={handlePlayClick}>
                Play
            </button>

            <button className="homePrimaryButton" onClick={onCollection}>
                Collection
            </button>

            {!isAuthenticated ? (
            <Login onSuccess={onLoginSuccess} />
            ) : (
            <>
                <button className="homePrimaryButton" onClick={onLogout}>
                    Logout
                </button>
            </>
            )}
        </div>

        <div className="homeHint">
            {!isAuthenticated
            ? "Login is optional — guest play is supported."
            : `Logged in as ${user?.email}`}
        </div>

        <DifficultyDialog
            open={difficultyOpen}
            onClose={() => setDifficultyOpen(false)}
            onPick={handlePickDifficulty}
        />
        </div>
    </div>
    );
};

export default Home;
